// extracted by mini-css-extract-plugin
module.exports = {"btnWrapper":"CartFooter_btnWrapper__cr_dJ","useFade-fadeIn":"CartFooter_useFade-fadeIn__qWsFP","useFade-fadeOut":"CartFooter_useFade-fadeOut__dL1dC"};